import Vue from 'vue'
import Router from 'vue-router'
import Main from '../pages/main'
import Home from '../pages/home'
import Site from '../pages/home/Site'
import realTime from '../pages/home/realTime'
import Equip from '../pages/equip'
import System from '../pages/systemSet'
import Login from '../pages/login/login'
import Analysis from '../pages/analysis';
import audioAnalysis from '../pages/home/audioAnalysis';
import warnSearch from '../pages/home/warnSearch';
import EquipElevator from '../pages/equip/elevator';
import Edges from '../pages/equip/edges';
import Sensor from '../pages/equip/sensor';
import passwdSet from '../pages/systemSet/passwdSet';
import operationSet from '../pages/systemSet/operationSet';
import userManagement from '../pages/systemSet/userManagement';
import siteManagement from '../pages/systemSet/siteManagement';
import Model from '../pages/model';
import temperature from '../pages/home/temperature';

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      // redirect: '/login'

      redirect: to => {
        const tokenStr = window.sessionStorage.getItem('token')
        if (tokenStr) {
          return {
            path: '/home',
            query: null
          }
        } else {
          return {
            path: '/login',
            query: null
          }
        }


      }
    },
    {
      path: '/analysis',
      component: Analysis
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: Login
    },
    {
      path: '/main',
      name: 'MainPage',
      component: Main,
      children: [{
          path: '/home',
          name: 'HomePage',
          component: Home,
          children: [{
              path: '/home/site',
              name: 'SitePage',
              component: Site
            },
            {
              path: '/home/realTime',
              name: 'realTimePage',
              component: realTime
            },
            {
              path: '/home/audioAnalysis',
              name: 'audioAnalysisPage',
              component: audioAnalysis
            },
            {
              path: '/home/warnSearch',
              name: 'warnSearchPage',
              component: warnSearch
            },
            {
              path: '/home/temperature',
              name: 'temperaturePage',
              component: temperature
            },
          ]
        },
        {
          path: '/equip',
          name: 'EquipPage',
          redirect: '/equip/elevator',
          component: Equip,
          children: [{
              path: '/equip/elevator',
              name: 'EquipElevatorPage',
              component: EquipElevator
            },
            {
              path: '/equip/edges',
              name: 'EdgesPage',
              component: Edges
            },
            {
              path: '/equip/sensor',
              name: 'SensorPage',
              component: Sensor
            },
          ]
        },
        {
          path: '/system',
          name: 'SystemPage',
          component: System,
          children: [{
              path: '/system/passwdSet',
              name: 'passwdSetPage',
              component: passwdSet
            },
            {
              path: '/system/operationSet',
              name: 'operationSetPage',
              component: operationSet
            },
            {
              path: '/system/userManagement',
              name: 'userManagementPage',
              component: userManagement
            },
            {
              path: '/system/siteManagement',
              name: 'siteManagementPage',
              component: siteManagement
            },

          ]
        },
        {
          path: '/model',
          name: 'Model',
          component: Model,
        },
       
        // {
        //   path: '/detail',
        //   name: 'DetailPage',
        //   component: Detail
        // },
        // {
        //   path: '/setting',
        //   name: 'Setting',
        //   component: Setting
        // },
      ]
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js